
(function() {
    // Backup das funções originais
    var originalFetch = window.fetch;
    var originalOpen = XMLHttpRequest.prototype.open;

    // Sobrescrever a função fetch
    window.fetch = function() {
        if (arguments[0].startsWith("https://app.sabinovision.com.br/")) {
            console.error("Blocked request to:", arguments[0]);
            return new Promise((resolve, reject) => {
                reject(new Error("Blocked request to " + arguments[0]));
            });
        }
        return originalFetch.apply(this, arguments);
    };

    // Sobrescrever a função open de XMLHttpRequest
    XMLHttpRequest.prototype.open = function() {
        if (arguments[1] && arguments[1].startsWith("https://app.sabinovision.com.br/")) {
            console.error("Blocked request to:", arguments[1]);
            this.abort();
        } else {
            originalOpen.apply(this, arguments);
        }
    };
})();

(function() {
    // Backup das funções originais
    var originalFetch = window.fetch;
    var originalOpen = XMLHttpRequest.prototype.open;

    // Sobrescrever a função fetch
    window.fetch = function() {
        if (arguments[0].startsWith("https://sabinovision.com.br/")) {
            console.error("Blocked request to:", arguments[0]);
            return new Promise((resolve, reject) => {
                reject(new Error("Blocked request to " + arguments[0]));
            });
        }
        return originalFetch.apply(this, arguments);
    };

    // Sobrescrever a função open de XMLHttpRequest
    XMLHttpRequest.prototype.open = function() {
        if (arguments[1] && arguments[1].startsWith("https://sabinovision.com.br/")) {
            console.error("Blocked request to:", arguments[1]);
            this.abort();
        } else {
            originalOpen.apply(this, arguments);
        }
    };
})();
